import * as React from "react";
import { createFeatureHub } from "@feature-hub/core";
import { loadAmdModule } from "@feature-hub/module-loader-amd";
import { FeatureAppLoader, FeatureHubContextProvider, } from "@feature-hub/react";
import { useQuery } from "@apollo/client";
import { OmIntegratorConfig } from "../queries/integrator";
import { gql } from "../../__generated__";
import { serviceConfigProviderFactory } from "./service-config-provider";
import { featureAppServiceFactory } from "./featureapp-service";
import { createAuthService } from "./auth-service";
const omIntegrator = gql(OmIntegratorConfig);
export const AppsView = ({ appName }) => {
    const { loading, data: integratorConfig } = useQuery(omIntegrator);
    if (loading || !integratorConfig) {
        return React.createElement("span", null, "loading...");
    }
    const { serviceConfigurations, featureAppConfigurations } = integratorConfig.omIntegratorConfig;
    const featureappService = featureAppServiceFactory(featureAppConfigurations);
    const serviceConfigProvider = serviceConfigProviderFactory(serviceConfigurations);
    const authService = createAuthService();
    const featureAppConfig = featureAppConfigurations.find((config) => config.name === appName);
    const { featureAppManager } = createFeatureHub("onehub-bot-integrator", {
        featureServiceDefinitions: [
            serviceConfigProvider,
            featureappService,
            authService,
        ],
        moduleLoader: loadAmdModule,
        providedExternals: {
            react: "18.3.1",
            "react-dom": "18.3.1",
            "@feature-hub/react": "3.8.0",
        },
    });
    if (!featureAppConfig) {
        return React.createElement("span", null,
            "Feature App Configuration not found for ",
            appName);
    }
    return (React.createElement(FeatureHubContextProvider, { value: { featureAppManager } },
        React.createElement(FeatureAppLoader, { featureAppId: "onehub-bot-ui", baseUrl: featureAppConfig.baseUrl, featureAppName: featureAppConfig.name, src: featureAppConfig.client, css: featureAppConfig.css.map((cssUrl) => {
                return { href: cssUrl };
            }) || [] })));
};
